import Cookies from 'js-cookie';
import { useVerifyQuery } from 'generated/graphql';
import { firebaseTokenFetch } from 'utils/firebase';
import { CookieNames } from 'constants/cookies';

function useFirebase() {
  useVerifyQuery({
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const msisdn = data?.user?.msisdn;
      if (msisdn) {
        const firebaseToken = Cookies.get(CookieNames.FIREBASE_TOKEN);
        const firebaseMSISDN = Cookies.get(CookieNames.FIREBASE_MSISDN) || '';
        const isOldMSISDN = `${msisdn}` === firebaseMSISDN;

        if (firebaseToken && msisdn && !isOldMSISDN) {
          firebaseTokenFetch({
            token: firebaseToken,
            oldToken: firebaseToken,
            msisdn,
          });
        } else {
          Cookies.set(CookieNames.FIREBASE_MSISDN, `${msisdn}`);
        }
      }
    },
  });
}

export default useFirebase;
